import { ReportConstants } from '../constants/report-constants';
import * as XLSX from 'xlsx';


export class ReportUtils {
  static validateNumberFilter(numberFilter): NumberFilterValidation {
    const info: NumberFilterValidation = {
      ban: '',
      subscriber: '',
      error: false,
      numberFilter: ''
    };
    if (numberFilter !== '') {
      if (numberFilter.length === 9) {
        info.ban = numberFilter;
      } else if (numberFilter.length === 10) {
        info.subscriber = numberFilter;
      } else {
        info.error = true;
      }
    } else {
      info.error = true;
    }
    return info;
  }

  static export(id, fileName) {
    {
      const name = `${fileName}.xlsx`;
      const element = document.getElementById(id);
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, name);
    }
  }

  static getTotalPages(paginator, rows): number {
    const totalPages = Math.trunc(rows / paginator);
    const residue = rows % paginator;
    const totalItems = residue === 0 ? totalPages : totalPages + 1;
    return totalItems;
  }

  static formatBackendDate(dateString: string): string {
    const date = {month: '', day: '', year: ''};
    ReportConstants.MONTHS.forEach((element, index) => {
      if (dateString.substring(0, 3) === element) {
        date.month = index < 9 ? `0${index + 1}` : `${index + 1}`;
      }
    });
    date.day = dateString.substring(4, 6).startsWith(' ') ? `0${dateString.substring(5, 6)}` : dateString.substring(4, 6);
    date.year = dateString.substring(7, 12);
    return `${date.month}-${date.day}-${date.year}`;
  }

  static fixDateFormat(date, param = 1): string {
    let day: string;
    let month: string;
    let year: string;
    let errorSpacing = 0;
    if (param === 1) {
      if (date.substring(0, 2).endsWith('/') || date.substring(0, 2).endsWith('-')) {
        month = `0${date.substring(0, 1)}`;
        errorSpacing++;
      } else {
        month = date.substring(0, 2);
      }

      if (errorSpacing === 1) {
        if (date.substring(2, 4).endsWith('/') || date.substring(2, 4).endsWith('-')) {
          day = `0${date.substring(2, 3)}`;
          errorSpacing++;
        } else {
          day = date.substring(2, 4);
        }
      } else {
        if (date.substring(3, 5).endsWith('/') || date.substring(3, 5).endsWith('-')) {
          day = `0${date.substring(3, 4)}`;
          errorSpacing++;
        } else {
          day = date.substring(3, 5);
        }
      }

      if (errorSpacing === 0) {
        year = date.substring(6, 10);
      } else if (errorSpacing === 1) {
        year = date.substring(5, 9);
      } else {
        year = date.substring(4, 8);
      }
      date = `${month}/${day}/${year}`;
    } else {
      year = date.substring(0, 4);
      if (date.substring(5, 6).endsWith('/') || date.substring(5, 6).endsWith('-')) {
        month = `0${date.substring(5, 6)}`;
      } else {
        month = date.substring(5, 7);
      }

      if (date.substring(8, 9).startsWith('/') || date.substring(8, 9).startsWith('-')) {
        day = `0${date.substring(8, 9)}`;
      } else {
        day = date.substring(8, 10);
      }
      date = `${month}/${day}/${year}`;
    }

    return date;
  }

  static fixFormatDateRequest(date: string) {
    const year = date.substring(0, 4);
    const monthString = date.substring(5, 7).replace('-', '');
    const dayString = date.substring(7, date.length).replace('-', '');
    const month = Number(monthString) < 10 ? '0' + Number(monthString) : Number(monthString);
    const day = Number(dayString) < 10 ? '0' + Number(dayString) : Number(dayString);
    return `${month}/${day}/${year}`;
  }

  static compareDates(initDate, endDate, date) {
    if (initDate !== '') {
      const init = new Date(initDate);
      const end = new Date(endDate);
      const dateForCompare = new Date(date);
      if (init < dateForCompare) {
        if (end > dateForCompare) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  static stringConverter(input): string {
    return input.toString().toUpperCase().trim();
  }
}

export interface NumberFilterValidation {
  ban: string;
  subscriber: string;
  error: boolean;
  numberFilter: string;
}
